import type { TOC } from '@ember/component/template-only';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface AppNotificationsPausedOrDiscountedComponentInterface {
	Args: object;
	Blocks: {
		default: [];
	}; // this is needed for yield
}

const AppNotificationsPausedOrDiscountedComponent: TOC<AppNotificationsPausedOrDiscountedComponentInterface> =
	<template>
		<div class="notification-container cancellation-action-notification">
			<CommonUiIconComponent @name="AlertFill" @size="sm" />
			<div>{{yield}}</div>
		</div>
	</template>;

export default AppNotificationsPausedOrDiscountedComponent;
